// 时钟
export var clock = typeof performance === 'object' && performance.now ? performance : Date;
//# sourceMappingURL=clock.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-gesture@1.0.0@@antv/g-gesture/esm/utils/clock.js
// module id = null
// module chunks = 